import { apiClient } from './client';

export interface ImageModelDTO {
  id: string;
  label: string;
  hint: string;
  priceSwipa: number;
}

export interface AiImageResult {
  mediaId: string;
  draftId: string | null;
  costSwipa: number;
  model: string;
  aspectRatio: '9:16' | '16:9' | '1:1';
}

export const aiImageApi = {
  async models() {
    const r = await apiClient.get('/api/ai-image/models');
    return r.data.models as ImageModelDTO[];
  },
  async generate(body: {
    prompt: string;
    modelId?: string;
    aspectRatio?: '9:16' | '16:9' | '1:1';
    /** Клиентский jobId (ref=gen:<jobId>) + txHash подписанной оплаты. */
    jobId: string;
    txHash: string;
  }) {
    const r = await apiClient.post('/api/ai-image', body);
    return r.data.result as AiImageResult;
  },
};
